import React, { useState } from 'react';
import { Users, Zap, List, MessageSquare, Mail, Repeat, Send } from 'lucide-react';
import { SocialAccounts } from './SocialAccounts';
import { SocialAutomations } from './SocialAutomations';
import { SocialQueue } from './SocialQueue';
import { SocialComments } from './SocialComments';
import { SocialMessages } from './SocialMessages';
import { CommentExchange } from './CommentExchange';
import InteractionAutoDM from './InteractionAutoDM';

type TabType = 'accounts' | 'automations' | 'messages' | 'comments' | 'exchange' | 'queue' | 'interaction-dm';

export function SocialInbox() {
  const [activeTab, setActiveTab] = useState<TabType>('accounts');

  const tabs = [
    { id: 'accounts' as TabType, label: 'Konta', icon: Users },
    { id: 'automations' as TabType, label: 'Automatyzacje', icon: Zap },
    { id: 'interaction-dm' as TabType, label: 'Auto DM po interakcji', icon: Send },
    { id: 'messages' as TabType, label: 'Wiadomości', icon: Mail },
    { id: 'comments' as TabType, label: 'Komentarze', icon: MessageSquare },
    { id: 'exchange' as TabType, label: 'Wymiana komentarzy', icon: Repeat },
    { id: 'queue' as TabType, label: 'Kolejka & Logi', icon: List },
  ];

  return (
    <div className="min-h-screen bg-gray-900 p-3 sm:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">Social Inbox</h1>
          <p className="text-sm sm:text-base text-gray-400">
            Zarządzaj wiadomościami i komentarzami z Facebook, Instagram, YouTube, TikTok i LinkedIn
          </p>
        </div>

        <div className="mb-4 sm:mb-6 border-b border-gray-700 overflow-x-auto">
          <div className="flex space-x-2 sm:space-x-8 min-w-max">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-2 sm:py-3 border-b-2 transition-colors whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'border-[#7B4BFF] text-white'
                      : 'border-transparent text-gray-400 hover:text-white'
                  }`}
                >
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span className="font-medium text-sm sm:text-base">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-6">
          {activeTab === 'accounts' && <SocialAccounts />}
          {activeTab === 'automations' && <SocialAutomations />}
          {activeTab === 'interaction-dm' && <InteractionAutoDM />}
          {activeTab === 'messages' && <SocialMessages />}
          {activeTab === 'comments' && <SocialComments />}
          {activeTab === 'exchange' && <CommentExchange />}
          {activeTab === 'queue' && <SocialQueue />}
        </div>
      </div>
    </div>
  );
}
